export function normalizeCommentContent(content) {
    const value = content || ''
    return value.replace(/<p><\/p>/g, '<p><br class="ProseMirror-trailingBreak"></p>')
}

export function isCommentEmpty(content, attachments = []) {
    const hasContent = content && content !== '<p></p>'
    const hasAttachments = Array.isArray(attachments) && attachments.length > 0
    return !hasContent && !hasAttachments
}

export function buildTaskCommentFormData(content, attachments = []) {
    const formData = new FormData()
    formData.append('content', normalizeCommentContent(content))
    attachments.forEach((file) => formData.append('attachments[]', file))
    return formData
}

export function splitCommentsByType(items = []) {
    const history = []
    const comments = []
    items.forEach((item) => {
        if (item.type === 'history') {
            history.push(item)
        } else {
            comments.push(item)
        }
    })
    return { history, comments }
}

export function getCommentFiles(comment) {
    if (!comment) return []
    if (Array.isArray(comment.files) && comment.files.length) {
        return comment.files
    }
    if (Array.isArray(comment.attachments) && comment.attachments.length) {
        return comment.attachments
    }
    return []
}
